import { createUseMutation } from 'api/common/createUseMutation'
import { deleteFavouritePractitioner } from 'api/fetchers/favourite/deleteFavouritePractitioner'
import { queryClient } from 'app/Root'
import { ApiQueryKeys } from 'constants/apiQueryKeys'

export const useDeleteFavouritePractitioner = createUseMutation({
  fetcher: deleteFavouritePractitioner,
  onSettled: async () => {
    await queryClient.invalidateQueries({ queryKey: [ApiQueryKeys.PRACTITIONERS] })
  },
})
